import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, nextTick } from 'vue';
import {
  Modal,
  InputText,
  Heading,
  InfiniteScroll,
  BaseText,
  ButtonPrimary,
  ButtonSecondary,
  ButtonContainer
} from '@warrenbrasil/nebraska-web';
import {
  getBackgroundImages,
  putBackgroundImage,
  IPhotos
} from '@/modules/wealth/services/portfolio';
import { BaseCard } from '@/modules/common/components/cards/BaseCard';
import { debounce } from 'lodash-es';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePortfolioBackgroundModal',
  props: {
  isOpen: { type: Boolean, default: false },
  portfolioId: { type: String, required: true },
  portfolioName: { type: String, required: true }
},
  emits: ['close', 'reload'],
  setup(__props, { emit }) {

const props = __props;




const imageInput = ref('');
const images = ref<IPhotos[]>([]);
const page = ref(1);
const modalStage = ref(1);
const chosenImage = ref<IPhotos | null>(null);
const scrollContainer = ref<HTMLElement | null>(null);
const modalSize = computed(() => (modalStage.value === 1 ? 'md' : 'sm'));
const updateKey = ref(0);
const scrollTopPosition = ref(0);

const fetchWithDebounce = debounce(() => {
  fetchPortfolioImages(true);
  updateKey.value++;
}, 500);
async function fetchPortfolioImages(restartPage: boolean) {
  const queryInfo = {
    query: imageInput.value,
    page: page.value,
    perPage: 10
  };
  const { photos } = await getBackgroundImages(queryInfo);
  if (restartPage) {
    images.value = [];
    page.value = 1;
    scrollContainer?.value && (scrollContainer.value.scrollTop = 0);
  } else {
    page.value += 1;
  }

  const existingImageIds = new Set(images.value.map(image => image.id));
  const uniquePhotos = photos.filter(photo => !existingImageIds.has(photo.id));

  uniquePhotos.forEach(photo => images.value.push(photo));
}
async function changeModalBackgroundImage(photo: IPhotos | null) {
  if (photo) {
    await putBackgroundImage(props.portfolioId, photo.urls);
    modalStage.value = 1;
    emit('close');
    emit('reload');
  }
}

function changeModalStage(stage: number, photo: IPhotos | null) {
  if (stage === 2 && scrollContainer.value) {
    scrollTopPosition.value = scrollContainer.value.scrollTop;
  }
  modalStage.value = stage;
  chosenImage.value = photo;
  nextTick(() => {
    if (stage === 1 && scrollContainer.value) {
      scrollContainer.value.scrollTop = scrollTopPosition.value;
    }
  });
}

return { __sfc: true,props, emit, imageInput, images, page, modalStage, chosenImage, scrollContainer, modalSize, updateKey, scrollTopPosition, fetchWithDebounce, fetchPortfolioImages, changeModalBackgroundImage, changeModalStage, Modal, InputText, Heading, InfiniteScroll, BaseText, ButtonPrimary, ButtonSecondary, ButtonContainer, BaseCard, NebraskaColors }
}

})